import React, { useState } from "react";
// Importar imágenes
import img2T from '../assets/honeypress-2t.jpg';
import img6T from '../assets/honeypress-6t.jpg';
import img10T from '../assets/honeypress-10t.jpg';
import img6TPro from '../assets/honeypress-6tpro.jpg';
import img10TPro from '../assets/honeypress-10tpro.jpg';

const modelos = [
  { value: "2T", label: "Honeypress 2T (básica)", pro: false },
  { value: "6T", label: "Honeypress 6T (básica)", pro: false },
  { value: "10T", label: "Honeypress 10T (básica)", pro: false },
  { value: "6TPro", label: "Honeypress 6T Pro (con manómetro)", pro: true },
  { value: "10TPro", label: "Honeypress 10T Pro (con manómetro)", pro: true }
];

const tiposMaterial = [
  { value: "flores", label: "Flores" },
  { value: "bubblehash", label: "Bubble Hash" },
  { value: "drysift", label: "Dry Sift" }
];

function ResultadoPresion({ modelo, tipoMaterial, cantidad, humedad, temperatura }) {
  // Valores base aproximados (pueden ajustarse según experiencia y feedback real)
  let presionIdealBar = 0;
  let presionIdealTexto = '';
  let ajusteHumedad = 1;
  let fuerza = undefined;

  // Ajuste de temperatura centralizado
  let ajusteTemp = 1;
  if (temperatura <= 95 && temperatura >= 65) {
    ajusteTemp = 1.3 - ((temperatura - 65) * 0.3 / 30);
  } else if (temperatura < 65) {
    ajusteTemp = 1.3;
  } else if (temperatura > 95) {
    ajusteTemp = 1.0;
  }

  // Ajuste por humedad
  if (humedad === 60) {
    ajusteHumedad = 0.7;
  } else if (humedad < 60 && humedad >= 40) {
    // Entre 40% y 60%, escala lineal de 1 a 0.7
    ajusteHumedad = 0.7 + 0.3 * ((60 - humedad) / 20);
    if (ajusteHumedad > 1) ajusteHumedad = 1;
    if (ajusteHumedad < 0.7) ajusteHumedad = 0.7;
  } else if (humedad < 40) {
    ajusteHumedad = 1; // No bajar más la fuerza
  } else if (humedad > 60) {
    // Por encima de 60%, disminuir gradualmente hasta 0.5 a 80%
    ajusteHumedad = 0.7 - 0.2 * ((humedad - 60) / 20);
    if (ajusteHumedad < 0.5) ajusteHumedad = 0.5;
  }

  // Ajustes según tipo de material
  if (tipoMaterial === 'flores') {
    // Flores: presión ideal entre 80 y 200 bar (Pro), fuerza proporcional en básicas
    if (modelo.endsWith('Pro')) {
      // Ajuste especial para 6T Pro
      if (modelo === '6TPro') {
        // Interpolación lineal entre 500bar (40% humedad, 30g) y 300bar (60% humedad, 30g)
        let maxGr = 30;
        let baseBar = 0;
        if (cantidad >= maxGr) {
          // Interpolar entre 40% y 60% humedad
          if (humedad <= 40) baseBar = 500;
          else if (humedad >= 60) baseBar = 300;
          else baseBar = 500 - ((humedad - 40) * (200 / 20)); // 200bar de diferencia en 20% humedad
        } else {
          // Para menos de 30g, escalar la presión máxima proporcionalmente
          let factor = cantidad / maxGr;
          let maxBar = 500 * factor;
          let minBar = 300 * factor;
          if (humedad <= 40) baseBar = maxBar;
          else if (humedad >= 60) baseBar = minBar;
          else baseBar = maxBar - ((humedad - 40) * ((maxBar - minBar) / 20));
        }
        presionIdealBar = baseBar;
        // Ajuste de temperatura
        let ajusteTemp = 1;
        if (temperatura <= 95 && temperatura >= 65) {
          ajusteTemp = 1.3 - ((temperatura - 65) * 0.3 / 30);
        } else if (temperatura < 65) {
          ajusteTemp = 1.3;
        } else if (temperatura > 95) {
          ajusteTemp = 1.0;
        }
        presionIdealBar = presionIdealBar * ajusteTemp;
        // Límites y redondeo
        if (presionIdealBar > 500) presionIdealBar = 500;
        if (presionIdealBar < 80) presionIdealBar = 80;
        presionIdealBar = Math.round(presionIdealBar);
        presionIdealTexto = `${presionIdealBar} bar`;
      } else if (modelo === '10TPro') {
        // 10T Pro: 50g máx, 600 bar (40% humedad), 300 bar (60% humedad)
        let maxGr = 50;
        let baseBar = 0;
        if (cantidad >= maxGr) {
          if (humedad <= 40) baseBar = 600;
          else if (humedad >= 60) baseBar = 300;
          else baseBar = 600 - ((humedad - 40) * (300 / 20)); // 300bar de diferencia en 20% humedad
        } else {
          let factor = cantidad / maxGr;
          let maxBar = 600 * factor;
          let minBar = 300 * factor;
          if (humedad <= 40) baseBar = maxBar;
          else if (humedad >= 60) baseBar = minBar;
          else baseBar = maxBar - ((humedad - 40) * ((maxBar - minBar) / 20));
        }
        presionIdealBar = baseBar;
        // Ajuste de temperatura
        let ajusteTemp = 1;
        if (temperatura <= 95 && temperatura >= 65) {
          ajusteTemp = 1.3 - ((temperatura - 65) * 0.3 / 30);
        } else if (temperatura < 65) {
          ajusteTemp = 1.3;
        } else if (temperatura > 95) {
          ajusteTemp = 1.0;
        }
        presionIdealBar = presionIdealBar * ajusteTemp;
        // Límites y redondeo
        if (presionIdealBar > 600) presionIdealBar = 600;
        if (presionIdealBar < 80) presionIdealBar = 80;
        presionIdealBar = Math.round(presionIdealBar);
        presionIdealTexto = `${presionIdealBar} bar`;
      } else {
        // Otros modelos Pro futuros
        presionIdealBar = 0;
        presionIdealTexto = '';
      }
    } else {
      // Lógica mejorada para modelos básicos
      let maxGr = 15;
      if (modelo === '6T') maxGr = 25;
      if (modelo === '10T') maxGr = 50;
      fuerza = (cantidad / maxGr) * 100 * ajusteHumedad * ajusteTemp;
      // Límites y redondeo
      if (fuerza > 100) fuerza = 100;
      if (fuerza < 10) fuerza = 10;
      fuerza = Math.round(fuerza);
      presionIdealTexto = `${fuerza}% de la fuerza máxima (para ${cantidad}g)`;
    }
  } else if (tipoMaterial === 'drysift') {
    // Dry Sift: presión baja, 40-80 bar (Pro), 20-50% fuerza (básica)
    if (modelo.endsWith('Pro')) {
      // Presión base según humedad (de 300 bar a 100 bar entre 30% y 60%)
      let presionBase = 0;
      if (humedad <= 30) presionBase = 300;
      else if (humedad >= 60) presionBase = 100;
      else presionBase = 300 - ((humedad - 30) * (200 / 30)); // 200 bar de diferencia en 30% humedad
      // Ajuste de temperatura: 65°C (+30%), 75°C (0%), interpolado
      let ajusteTempPro = 1;
      if (temperatura <= 65) ajusteTempPro = 1.3;
      else if (temperatura >= 75) ajusteTempPro = 1.0;
      else ajusteTempPro = 1.3 - ((temperatura - 65) * 0.3 / 10);
      presionIdealBar = presionBase * ajusteTempPro;
      presionIdealBar = Math.round(presionIdealBar);
      presionIdealTexto = `${presionIdealBar} bar`;
    } else {
      let maxGr = 15;
      if (modelo === '6T') maxGr = 25;
      if (modelo === '10T') maxGr = 50;
      fuerza = (cantidad / maxGr) * 50 * ajusteHumedad * ajusteTemp;
      // Límites y redondeo
      if (fuerza > 50) fuerza = 50;
      if (fuerza < 20) fuerza = 20;
      fuerza = Math.round(fuerza);
      presionIdealTexto = `${fuerza}% de la fuerza máxima (para ${cantidad}g)`;
    }
  } else if (tipoMaterial === 'bubblehash') {
    // Bubble Hash: presión muy baja, 20-50 bar (Pro), 10-30% fuerza (básica)
    if (modelo.endsWith('Pro')) {
      // Presión base según humedad (de 300 bar a 100 bar entre 30% y 60%)
      let presionBase = 0;
      if (humedad <= 30) presionBase = 300;
      else if (humedad >= 60) presionBase = 100;
      else presionBase = 300 - ((humedad - 30) * (200 / 30)); // 200 bar de diferencia en 30% humedad
      // Ajuste de temperatura: 65°C (+30%), 75°C (0%), interpolado
      let ajusteTempPro = 1;
      if (temperatura <= 65) ajusteTempPro = 1.3;
      else if (temperatura >= 75) ajusteTempPro = 1.0;
      else ajusteTempPro = 1.3 - ((temperatura - 65) * 0.3 / 10);
      presionIdealBar = presionBase * ajusteTempPro;
      presionIdealBar = Math.round(presionIdealBar);
      presionIdealTexto = `${presionIdealBar} bar`;
    } else {
      let maxGr = 15;
      if (modelo === '6T') maxGr = 25;
      if (modelo === '10T') maxGr = 50;
      fuerza = (cantidad / maxGr) * 30 * ajusteHumedad;
      // Ajuste gradual por temperatura
      fuerza = fuerza * ajusteTemp;
      // Ahora sí, aplicar límites y redondear
      if (fuerza > 30) fuerza = 30;
      if (fuerza < 10) fuerza = 10;
      fuerza = Math.round(fuerza);
      presionIdealTexto = `${fuerza}% de la fuerza máxima (para ${cantidad}g)`;
    }
  }

  return (
    <>
      {(tipoMaterial === 'bubblehash' || tipoMaterial === 'drysift') && temperatura > 75 && (
        <div style={{background:'#ffbaba', color:'#900', border:'2px solid #f44336', padding:'1em', borderRadius:10, marginBottom:'1em', fontWeight:'bold', textAlign:'center'}}>
          ¡Atención! Mayores temperaturas te hará perder gran porcentaje de calidad.
        </div>
      )}
      <div style={{background:'#ffbaba', border:'2px solid #ffb300', color:'#222', padding:'1em', borderRadius:10, marginBottom:'1em', fontWeight:'bold', fontSize:'1.2em', textAlign:'center'}}>
        Presión ideal recomendada: <span style={{color:'#b26500'}}>{presionIdealTexto}</span>
      </div>
    </>
  );
}

function Recomendaciones({ modelo, cantidad, humedad, temperatura, tipoMaterial }) {
   // Rango recomendado
   let tempMsg = '';
  if (tipoMaterial === 'flores') {
    if (temperatura < 50) {
      tempMsg = 'No obtendrás retorno.';
    } else if (temperatura >= 50 && temperatura < 60) {
      tempMsg = 'Eleva tu temperatura o sacrificarás mucho retorno.';
    } else if (temperatura >= 60 && temperatura < 70) {
      tempMsg = '¡Rango ideal para obtener la mejor calidad conservando un retorno decente!';
    } else if (temperatura >= 70 && temperatura < 80) {
      tempMsg = 'Temperatura ideal donde calidad y retorno van parejos!';
    } else if (temperatura >= 80 && temperatura < 90) {
      tempMsg = 'Mejor retorno pero sacrificaremos terpenos en el proceso.';
    } else if (temperatura >= 90 && temperatura < 95) {
      tempMsg = 'Aún podemos conservar algo de calidad, depende mucho de la genética.';
    } else if (temperatura >= 95) {
      tempMsg = '¡Ahora vamos solo por ese retorno!!!';
    } else {
      tempMsg = '';
    }
  } else {
    if (temperatura < 75) tempMsg = 'Temperatura baja: ideal para máxima calidad, pero menor cantidad.';
    else if (temperatura > 98) tempMsg = 'Temperatura alta: mayor cantidad, menor calidad y terpenos.';
    else tempMsg = 'Temperatura media: buen equilibrio entre cantidad y calidad.';
  }

  // Tiempo recomendado
  let tiempoMsg = '';
  if (tipoMaterial === 'drysift' || tipoMaterial === 'bubblehash') {
    if (temperatura >= 60 && temperatura <= 69) tiempoMsg = 'Tiempo largo (5-15 min).';
    else if (temperatura >= 70 && temperatura <= 75) tiempoMsg = 'Tiempo medio (3-5 min).';
    else if (temperatura > 75) tiempoMsg = 'Tiempo corto (1-2 min).';
    else tiempoMsg = '';
  } else {
    if (temperatura > 98) tiempoMsg = 'Tiempo corto (30-60s).';
    else if (temperatura < 75) tiempoMsg = 'Tiempo largo (2-3 min).';
    else tiempoMsg = 'Tiempo medio (1-2 min).';
  }

  // Humedad recomendada
  let humedadMsg = '';
  if (tipoMaterial === 'drysift' || tipoMaterial === 'bubblehash') {
    if (humedad < 30) {
      humedadMsg = 'Humedad muy baja, te recomendamos humedecer tu materia vegetal antes de prensar.';
    } else if (humedad >= 30 && humedad < 40) {
      humedadMsg = 'Humedad correcta: buen retorno y buena conservación de terpenos.';
    } else if (humedad >= 40 && humedad < 50) {
      humedadMsg = 'Humedad relativamente alta, recomendamos reducir la presión de apriete.';
    } else if (humedad >= 50 && humedad <= 60) {
      humedadMsg = 'Humedad alta, recomendamos reducir la presión y aumentar un par de grados la temperatura.';
    } else if (humedad > 60) {
      humedadMsg = 'Humedad muy alta, el retorno incluirá más agua y deberás ajustar presión y temperatura.';
    }
  } else if (tipoMaterial === 'flores') {
    if (humedad >= 0 && humedad < 40) {
      humedadMsg = 'Humedece tu materia vegetal, puedes probar el método que más te guste, el más rápido y efectivo es la humedad que te entrega el vapor!';
    } else if (humedad >= 40 && humedad < 50) {
      humedadMsg = 'Humedad relativamente baja: obtendrás un decente retorno y una buena calidad si la genética te acompaña!';
    } else if (humedad >= 50 && humedad < 60) {
      humedadMsg = 'Humedad correcta, la mejor humedad precalienta 1 min la pieza y haz tu apriete te espera un buen retorno sera mejor si la genetica esta contigo.';
    } else if (humedad >= 60 && humedad < 70) {
      humedadMsg = 'Humedad relativamente alta, te recomendamos reducir la presión final, haz presión paulatina y lenta. Deja la pieza pre-calentar 2 min en vez de 1 min.';
    } else if (humedad >= 70) {
      humedadMsg = '¡Espérate! Deja a esa flor secar unos días, vuelve a revisar mañana a ver qué tal :)';
    } else {
      humedadMsg = '';
    }
  } else {
    humedadMsg = '';
  }

  return (
    <div
      style={{
        background: '#fff9c4',
        color: '#222',
        padding: '1.1em 0.7em',
        borderRadius: 13,
        border: '2px solid #ffe082',
        boxShadow: '0 2px 8px #ffe082',
        width: '100%',
        maxWidth: 500,
        minWidth: 0,
        margin: '2em auto 0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        boxSizing: 'border-box',
      }}
    >
      <h3 style={{color:'#b67c00', fontSize:'1.18em', textAlign:'center', marginBottom: 10, letterSpacing:0.5}}>Recomendaciones Generales</h3>
      <ul style={{lineHeight: 1.7, color:'#222', fontSize:'1em', width:'100%', paddingLeft:18, paddingRight:10, boxSizing:'border-box'}}>
        <li style={{marginBottom:6}}><b style={{color:'#ffb300'}}>Temperatura:</b> {tempMsg}</li>
        <li style={{marginBottom:6}}><b style={{color:'#ffb300'}}>Presión:</b> La presión/fuerza se calcula automáticamente según el modelo, cantidad y humedad.</li>
        <li style={{marginBottom:6}}><b style={{color:'#ffb300'}}>Tiempo:</b> {tiempoMsg}</li>
        {humedadMsg && <li style={{marginBottom:6}}><b style={{color:'#ffb300'}}>Humedad:</b> {humedadMsg}</li>}
      </ul>
      <div style={{fontSize: '0.97em', color: '#b67c00', marginTop: '1em', textAlign:'center', wordBreak:'break-word'}}>
        Recuerda: La calidad y cantidad final dependen de todos estos factores y de la experiencia.<br/>
        Consulta siempre el manual de tu prensa y utiliza protección adecuada.
      </div>
    </div>
  );
}

export default function Calculator() {
  // Fondo negro para toda la pestaña Presiómetro
  React.useEffect(() => {
    document.body.style.background = '#000';
    return () => { document.body.style.background = ''; };
  }, []);

  const [modelo, setModelo] = useState("6T");
  const [tipoMaterial, setTipoMaterial] = useState("flores");
  const [cantidad, setCantidad] = useState(5);
  const [humedad, setHumedad] = useState(60);
  const [temperatura, setTemperatura] = useState(90);

  // Límites máximos por modelo
  const maxPorModelo = {
    '2T': 20,
    '6T': 30,
    '10T': 45,
    '6TPro': 30,
    '10TPro': 45
  };

  // Funciones de manejo de cambios
  const handleTemperaturaChange = (e) => {
    const val = e.target.value;
    if (val === '' || val === undefined) {
      setTemperatura(0);
    } else {
      setTemperatura(Math.max(0, Math.min(120, Number(val))));
    }
  };

  const handleHumedadChange = (e) => {
    const val = e.target.value;
    if (val === '' || val === undefined) {
      setHumedad(0);
    } else {
      setHumedad(Math.max(0, Math.min(100, Number(val))));
    }
  };

  const handleCantidadChange = (e) => {
    const val = e.target.value;
    if (val === '' || val === undefined) {
      setCantidad(0);
    } else {
      const max = maxPorModelo[modelo] || 0;
      setCantidad(Math.max(0, Math.min(max, Number(val))));
    }
  };

  const modeloActual = modelos.find(m => m.value === modelo);

  // Las imágenes ya están importadas al inicio del archivo

  // Relación modelo -> imagen
  // Solo prueba con la imagen de 2T (import estático)
  const modeloImagen = {
    '2T': img2T,
    '6T': img6T,
    '10T': img10T,
    '6TPro': img6TPro,
    '10TPro': img10TPro,
  };

  return (
    <div style={{
      background: '#000',
      minHeight: '100vh',
      width: '100%',
      maxWidth: '100%',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '32px 16px',
      boxSizing: 'border-box'
    }}>
      <h2 style={{
        color: '#fff',
        fontSize: '2.4em',
        fontWeight: 800,
        letterSpacing: '.01em',
        marginBottom: '16px'
      }}>Presiómetro</h2>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '1.2em 0 1.5em 0',
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        padding: '0 16px',
        boxSizing: 'border-box'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1.5em',
          width: '100%',
          maxWidth: '100%',
          position: 'relative'
        }}>
          <button
            type="button"
            aria-label="Modelo anterior"
            onClick={() => setModelo(modelos[(modelos.findIndex(m => m.value === modelo) - 1 + modelos.length) % modelos.length].value)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '2.8em',
              color: '#ffb300',
              cursor: 'pointer',
              padding: '0 0.1em',
              flexShrink: 0
            }}
          >
            &#8592;
          </button>
          <div style={{
            maxWidth: '40%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            margin: '0 10px'
          }}>
            <img
              src={modeloImagen[modelo]}
              alt={modelos.find(m=>m.value===modelo)?.label || 'Modelo Honeypress'}
              style={{
                maxWidth: '100%',
                maxHeight: '200px',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          </div>
          <button
            type="button"
            aria-label="Modelo siguiente"
            onClick={() => setModelo(modelos[(modelos.findIndex(m => m.value === modelo) + 1) % modelos.length].value)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '2.8em',
              color: '#ffb300',
              cursor: 'pointer',
              padding: '0 0.1em',
              flexShrink: 0
            }}
          >
            &#8594;
          </button>
        </div>
        <div style={{marginTop:'0.7em',fontWeight:'bold',fontSize:'1.23em',color:'#ffb300',textAlign:'center',letterSpacing:'0.01em',textShadow:'0 2px 12px #fffbe633, 0 1px 2px #00000022'}}>
          {modelos.find(m=>m.value===modelo)?.label}
        </div>
      </div>
      <form style={{
        maxWidth: '500px',
        width: '100%',
        padding: '0 16px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.2em',
        boxSizing: 'border-box',
        alignItems: 'center'
      }}>
        {/* El select de modelo se elimina, el modelo se elige solo con las flechas */}
        <label style={{
          width: '100%',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5em'
        }}>
          <span style={{ alignSelf: 'flex-start' }}>Tipo de material:</span>
          <select 
            value={tipoMaterial} 
            onChange={e => setTipoMaterial(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: '#2a2a2a',
              color: '#fff'
            }}
          >
            <option value="flores">Flores</option>
            <option value="drysift">Dry Sift</option>
            <option value="bubblehash">Bubble Hash</option>
          </select>
        </label>
        <label style={{
          width: '100%',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5em'
        }}>
          <span style={{ alignSelf: 'flex-start' }}>Cantidad de material (g):</span>
          <input
            type="number"
            min={0}
            max={maxPorModelo[modelo] || 0}
            value={cantidad === 0 ? '' : cantidad}
            onChange={handleCantidadChange}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: '#2a2a2a',
              color: '#fff'
            }}
          />
          <span style={{
            color: '#b67c00',
            fontSize: '0.97em',
            marginLeft: 8,
            whiteSpace: 'nowrap',
            display: 'inline-block'
          }}>
            (máx: {maxPorModelo[modelo] || 0}g)
          </span>
        </label>
        <label style={{
          width: '100%',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5em'
        }}>
          <span style={{ alignSelf: 'flex-start' }}>Humedad (%):</span>
          <input
            type="number"
            min={0}
            max={100}
            value={humedad === 0 ? '' : humedad}
            onChange={handleHumedadChange}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: '#2a2a2a',
              color: '#fff'
            }}
          />
        </label>
        <label style={{
          width: '100%',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5em'
        }}>
          <span style={{ alignSelf: 'flex-start' }}>Temperatura (°C):</span>
          <input
            type="number"
            min={0}
            max={120}
            value={temperatura === 0 ? '' : temperatura}
            onChange={handleTemperaturaChange}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: '#2a2a2a',
              color: '#fff'
            }}
          />
        </label>

      </form>
      <div style={{marginTop: '2em'}}>
        <ResultadoPresion
          modelo={modelo}
          tipoMaterial={tipoMaterial}
          cantidad={cantidad}
          humedad={humedad}
          temperatura={temperatura}
        />
        {/* Advertencia si se supera 600 bar en 10T Pro */}
        {modelo === '10TPro' && (() => {
          // Recalcular presión ideal para mostrar advertencia si corresponde
          let presion = 0;
          let ajusteHumedad = 1;
          if (humedad === 60) {
            ajusteHumedad = 0.7;
          } else if (humedad < 60 && humedad >= 40) {
            ajusteHumedad = 0.7 + 0.3 * ((60 - humedad) / 20);
            if (ajusteHumedad > 1) ajusteHumedad = 1;
            if (ajusteHumedad < 0.7) ajusteHumedad = 0.7;
          } else if (humedad < 40) {
            ajusteHumedad = 1;
          } else if (humedad > 60) {
            ajusteHumedad = 0.7 - 0.2 * ((humedad - 60) / 20);
            if (ajusteHumedad < 0.5) ajusteHumedad = 0.5;
          }
          if (tipoMaterial === 'flores') {
            if (temperatura > 98) presion = 90;
            else if (temperatura < 75) presion = 160;
            else presion = 120;
            presion += (cantidad - 5) * 5;
            if (presion < 80) presion = 80;
            presion = Math.round(presion * ajusteHumedad);
          } else if (tipoMaterial === 'drysift') {
            presion = 60 + (cantidad - 5) * 2;
            if (presion > 90) presion = 90;
            if (presion < 40) presion = 40;
            presion = Math.round(presion * ajusteHumedad);
          } else if (tipoMaterial === 'bubblehash') {
            presion = 30 + (cantidad - 5);
            if (presion > 50) presion = 50;
            if (presion < 20) presion = 20;
            presion = Math.round(presion * ajusteHumedad);
          }
          if (presion > 600) {
            return (
              <div style={{background:'#ffbaba', color:'#900', border:'2px solid #f44336', padding:'1em', borderRadius:10, margin:'1em 0', fontWeight:'bold', textAlign:'center'}}>
                ¡Cuidado! Presiones superiores a 600 bar son innecesarias en la 10T Pro.
              </div>
            );
          }
          return null;
        })()}

        {/* Alerta de humedad para flores */}
        {tipoMaterial === 'flores' && humedad < 40 && (
          <div style={{background:'#fff3cd', color:'#856404', border:'2px solid #ffe082', padding:'1em', borderRadius:10, margin:'1em 0', fontWeight:'bold', textAlign:'center'}}>
            ¡Atención! La humedad es menor al 40%.<br/>
            Te recomendamos humedecer tu materia vegetal antes de prensar. Puedes usar el método que prefieras, pero el más rápido es por vapor de agua.
          </div>
        )}
        {/* Alerta de humedad para drysift */}
        {tipoMaterial === 'drysift' && humedad < 35 && (
          <div style={{background:'#fff3cd', color:'#856404', border:'2px solid #ffe082', padding:'1em', borderRadius:10, margin:'1em 0', fontWeight:'bold', textAlign:'center'}}>
            ¡Atención! La humedad es menor al 35%.<br/>
            Te recomendamos humedecer tu materia vegetal antes de prensar.
          </div>
        )}
        {/* Alerta de humedad para bubble hash */}
        {tipoMaterial === 'bubblehash' && humedad < 30 && (
          <div style={{background:'#fff3cd', color:'#856404', border:'2px solid #ffe082', padding:'1em', borderRadius:10, margin:'1em 0', fontWeight:'bold', textAlign:'center'}}>
            ¡Atención! La humedad es menor al 30%.<br/>
            Te recomendamos humedecer tu materia vegetal antes de prensar.
          </div>
        )}
        <Recomendaciones
          modelo={modelo}
          cantidad={cantidad}
          humedad={humedad}
          temperatura={temperatura}
          tipoMaterial={tipoMaterial}
        />
      </div>
    </div>
  );
}
